import React from "react";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import { makeStyles } from "@material-ui/styles";
import { useDeepEffect, useDeepMemo, useSafeState } from "../../../hooks";
import { isEmpty } from "../../../utils/helpers";
import MuiTable from "../../../components/MuiTable";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#fafafa",
    flex: 1
  }
}));

const invoiceColumns = [
  { dataKey: "invoiceNo", title: "Invoice No" },
  { dataKey: "itemCode", title: "Item Code" },
  { dataKey: "itemColor", title: "Item Color" },
  { dataKey: "colorShade", title: "Color Shade" },
  { dataKey: "fpo", title: "FPO" },
  { dataKey: "qty", title: "Qty" }
];

const rollColumns = [
  { dataKey: "rollNo", title: "Roll No" },
  { dataKey: "okUnits", title: "Ok Units" },
  { dataKey: "rejectUnits", title: "Reject Units" },
  { dataKey: "colorShade", title: "Color Shade" },
  { dataKey: "excessUnits", title: "Excess Units" },
  { dataKey: "cuttableWidth", title: "Cuttable Width" },
  { dataKey: "warpShrPercent", title: "Warp Shr Percent" },
  { dataKey: "weftShrPercent", title: "Weft Shr Percent" },
  { dataKey: "skewnessValue", title: "Skewness Value" },
  { dataKey: "shade", title: "Shade" },
  { dataKey: "csv", title: "CSV" }
];

const ExternalRollDetails = ({ userActivity }) => {
  const classes = useStyles();
  const [selectedKey, setSelectedKey] = useSafeState(null);

  const invoice = JSON.parse(userActivity?.request || "{}");

  const invoiceRows = useDeepMemo(() => {
    if (isEmpty(invoice)) return [];
    const rows = invoice?.fabricItemList?.map(fb => ({ invoiceNo: invoice?.invoiceNo, ...fb }));
    return rows;
  }, [invoice]);

  useDeepEffect(() => {
    if (invoiceRows) return;
    if (isEmpty(selectedKey)) {
      setSelectedKey(invoiceRows[0]?.externalId);
    }
  }, [invoiceRows]);

  const rollRows = useDeepMemo(() => {
    if (isEmpty(selectedKey)) return [];
    if (isEmpty(invoiceRows)) return [];
    const row = invoiceRows.find(i => selectedKey === i.externalId);
    const rows = row.supplierRollList;
    return rows;
  }, [selectedKey, invoiceRows]);

  return (
    <PerfectScrollbar className={classes.root}>
      <div style={{ padding: 16 }}>
        <MuiTable
          columns={invoiceColumns}
          rows={invoiceRows}
          onRowClick={row => setSelectedKey(row.externalId)}
          rowStyle={({ row, rowIdx }) => (selectedKey === row?.externalId ? { backgroundColor: "#BFDDF8" } : {})}
        />
      </div>

      {!isEmpty(rollRows) && (
        <div style={{ padding: 16 }}>
          <MuiTable columns={rollColumns} rows={rollRows} />
        </div>
      )}
    </PerfectScrollbar>
  );
};

export default ExternalRollDetails;
